export const state = () => {
  return {
    scrollEnabled: true,
    scrollbarGapWidth: 0,
  }
}
